import { render, staticRenderFns } from "./RewardSection.vue?vue&type=template&id=1d522916&"
import script from "./RewardSection.vue?vue&type=script&lang=js&"
export * from "./RewardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports